import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Send } from "lucide-react";
import AuthLayout from "../components/AuthLayout";
import { api, errMsg } from "../lib/api";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [devToken, setDevToken] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(true);
      if (data.dev_token) setDevToken(data.dev_token);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="text-2xl font-extrabold mb-1" data-testid="forgot-title">
        Reset your password
      </h2>
      <p className="text-tv-sub text-sm mb-7">
        Enter your email and we'll generate a secure reset link.
      </p>

      {err && <div className="mb-4 text-sm text-tv-red bg-tv-red/10 border border-tv-red/30 rounded-xl px-4 py-3">{err}</div>}

      {done ? (
        <div className="card p-5" data-testid="forgot-success">
          <p className="text-tv-text text-sm">
            Thanks. Your password reset request for <b>{email}</b> has been sent to our support team
            (<span className="text-tv-cyan">support@mediaverselabs.com</span>). They'll help you reset it shortly.
          </p>
          {devToken && (
            <div className="mt-4">
              <p className="text-xs text-tv-muted mb-2">
                No email service is configured yet, so here is your reset link (dev mode):
              </p>
              <Link
                to={`/reset-password?token=${devToken}`}
                className="text-tv-cyan text-sm font-semibold break-all hover:underline"
                data-testid="forgot-dev-link"
              >
                /reset-password?token={devToken}
              </Link>
            </div>
          )}
          <Link to="/login" className="btn-ghost inline-block mt-5">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-tv-sub mb-1.5 block">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-tv-muted" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="field pl-10" data-testid="forgot-email-input" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="forgot-submit-button">
            {loading ? <span className="spinner" /> : <Send size={17} />}
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}

      <p className="text-center text-sm text-tv-sub mt-6">
        <Link to="/login" className="text-tv-cyan font-semibold hover:underline">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
